import React from "react";
import PropTypes from "prop-types";
import { confirmable, createConfirmation } from "react-confirm";
import CustomDatePicker, {
  DatePickerInput
} from "../../../forms/fields/CustomDatePicker";
import DatePicker from "react-datepicker";
import Modal from "../../../../base/Modal";
import moment from "moment";

class ConfirmForcedRentalModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      endDate: null
    };

    if (props.show) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }

  static propTypes = {
    show: PropTypes.bool, // from confirmable. indicates if the dialog is shown or not.
    proceed: PropTypes.func, // from confirmable. call to close the dialog with promise resolved.
    cancel: PropTypes.func, // from confirmable. call to close the dialog with promise rejected.
    dismiss: PropTypes.func, // from confirmable. call to only close the dialog.
    confirmation: PropTypes.string, // arguments of your confirm function
    options: PropTypes.object // arguments of your confirm function
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }

  _handleChange = value => {
    this.setState(state => ({
      ...state,
      endDate: value
    }));
  };

  _handleProceed = () => {
    const { proceed } = this.props;
    proceed({
      endDate: this.state.endDate?.format("YYYY-MM-DD") ?? null
    });
  };

  render() {
    const {
      show,
      proceed,
      dismiss,
      cancel,
      confirmation,
      label,
      options
    } = this.props;

    return [
      <div
        key="modal"
        className={"modal fade " + (show ? "show" : "")}
        id="m_modal_1"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        style={{ display: show ? "block" : "none" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {options.title}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={dismiss}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body" style={{ height: "400px" }}>
              <p>{confirmation}</p>
              <div className="form-group m-form__group">
                {label && <label htmlFor={name}>{label}</label>}

                <DatePicker
                  style={{ zIndex: 500 }}
                  customInput={
                    <DatePickerInput {...this.props} HTMLname={name} />
                  }
                  selected={this.state.endDate ?? moment()}
                  onChange={this._handleChange}
                  dateFormat="DD/MM/YYYY"
                  minDate={moment(new Date())}
                  maxDate={moment(
                    new Date(Date.now() + 120 * 24 * 60 * 60 * 1000)
                  )}
                  showMonthDropdown={true}
                  showYearDropdown={true}
                  dropdownMode="select"
                />

                {/*{help && <span className="m-form__help">{help}</span>}*/}

                {/*{touched[name] && errors[name] && (*/}
                {/*  <div className="form-control-feedback">{errors[name]}</div>*/}
                {/*)}*/}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={cancel}
              >
                Cancel
              </button>
              <button
                type="button"
                className={
                  "btn " +
                  (options.confirmStyle ? options.confirmStyle : "btn-primary")
                }
                onClick={this._handleProceed}
              >
                {options.confirmText ? options.confirmText : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      </div>,
      <div
        key="backdrop"
        className={"modal-backdrop fade " + (show ? "show" : "")}
      />
    ];
  }
}

// confirmable HOC pass props `show`, `dismiss`, `cancel` and `proceed` to your component.
//  confirmable(ConfirmForcedRentalModal);

const confirm = createConfirmation(confirmable(ConfirmForcedRentalModal));

export default function(confirmation, options = {}) {
  return confirm({ confirmation, options });
}
